import { render, staticRenderFns } from "./RaceRunnersSection.vue?vue&type=template&id=6d4ed382&"
import script from "./RaceRunnersSection.vue?vue&type=script&lang=js&"
export * from "./RaceRunnersSection.vue?vue&type=script&lang=js&"
import style0 from "./RaceRunnersSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VDataTable,VImg})
